module.exports = __webpack_public_path__ + "img/farm-work.996f7271.png";